module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lng_en":{"buttonText":"See all products"},"lng_id":{"buttonText":"Lihat semua produk"},"lng_th":{"buttonText":"ดูสินค้าทั้งหมด"},"lng_zh":{"buttonText":"查看全部產品"},"lng_ko":{"buttonText":"전체 상품 보기"}}')
  delete Component.options._Ctor
}
